export default __webpack_public_path__ + "static/media/paysera.832c9841.png";